<div style="width: 40px;
    height: 40px;
    background-color: #1581c3;
    border-radius: 4px;
    text-align: center;
    vertical-align: middle;
    display: flex;
    cursor: pointer;
    z-index: 9999;" (click)="modalNotifications.present()" *ngIf="user != null && !user.avatar">
  <ion-badge slot="end" color="success" *ngIf="notifNbNotRead > 0" style="
    position: absolute;
    font-size: 8pt;
    right: 0px;
    top: 0px;
    padding-left: 6px;
    padding-right: 6px;" (click)="modalNotifications.present()">{{notifNbNotRead}}</ion-badge>
  <ion-label style="color: #fff;
    font-weight: bold;
    vertical-align: middle;
    margin: auto;
    font-size: 1em; white-space: nowrap;" (click)="modalNotifications.present()">{{initial}}</ion-label>
</div>

<div style="width: 40px;
    height: 40px;
    text-align: center;
    vertical-align: middle;
    display: flex;
    cursor: pointer;
    z-index: 9999;" (click)="modalNotifications.present()" *ngIf="user != null && user.avatar">
  <ion-badge slot="end" color="success" *ngIf="notifNbNotRead > 0" style="
    position: absolute;
    font-size: 8pt;
    right: 0px;
    top: 0px;
    padding-left: 6px;
    padding-right: 6px;" (click)="modalNotifications.present()">{{notifNbNotRead}}</ion-badge>
  <ion-avatar *ngIf="user.avatar" style="height: 100%; width: 100%">
    <img src="{{user.avatar}}">
  </ion-avatar>
</div>


<ion-modal #modalNotifications>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="modalNotifications.dismiss()" [strong]="true">{{ 'Close' | translate }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-list>
        <ion-item lines="none" *ngIf="notifications.length == 0">
          <ion-label class="ion-text-wrap" color="primary">{{ 'You do not yet have a notification.' | translate }}</ion-label>
        </ion-item>
        <ion-item *ngFor="let notif of notifications" (click)="notifOpenCB(notif);" lines="full" [color]="notif['isRead'] ? 'light': ''" button>
          <ion-grid><ion-row><ion-col>
            <ion-label class="ion-text-wrap" style="font-weight: bold;">{{notif['title']}}</ion-label>
          </ion-col><ion-col size="auto" style="text-align: right;">
            <ion-label class="ion-text-wrap">{{notif['date']}}</ion-label>
          </ion-col></ion-row><ion-row><ion-col>
            <ion-label class="ion-text-wrap">{{notif['body']}}</ion-label>
          </ion-col></ion-row></ion-grid>
        </ion-item>
      </ion-list>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="markAllAsReadCB()" [strong]="true">{{ 'Mark all as read' | translate }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>